import { iconMapping } from "@components/IconExplanation/data";
import Link from "@components/Link";
import RichText from "@components/RichText";
import { FlexBox, Text } from "@styles";
import React, { ReactElement } from "react";
import styled from "styled-components";
import { ContentItem } from "@typed/content";

interface ResourceListProps {
  items: ContentItem[];
  ifEmpty?: ReactElement | null;
}

const FlatList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  height: max-content;
  gap: 0.75rem;
`;

const TextAlignment = styled(FlexBox)`
  flex-direction: column;
  overflow: hidden;
  gap: 0.1rem;
`;

const tempMap: { [key: string]: string } = { "health-and-safety": "safety-data-sheets", "lesson-plan": "technical-info" };

const ResourceList = ({ items, ifEmpty = null }: ResourceListProps) => {
  if (!items.length) {
    return ifEmpty;
  }

  return (
    <FlatList>
      {items.map(({ id, type, title, description, slug }) => {
        let contentType = iconMapping[type ?? ""] ?? iconMapping[tempMap[type ?? ""]];

        if (!contentType) contentType = iconMapping["reference-material"];

        return (
          <Link to={slug} key={id}>
            <FlexBox align-items="flex-start">
              <img src={contentType.image} width={32} height={32} alt={contentType.name} />
              <TextAlignment>
                {title ? (
                  <Text size={0.9} bold>
                    {title}
                  </Text>
                ) : null}
                <RichText customStyle={{ fontSize: "0.9rem", lineHeight: 1 }} body={description} line={2} />
              </TextAlignment>
            </FlexBox>
          </Link>
        );
      })}
    </FlatList>
  );
};

export default ResourceList;
